/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {DatepickerHelperService} from '../../shared/utils/datepicker-helper/datepicker-helper.service';
import {DateModel} from '../models/date/date.model';

export function percentPipe(cellValue: number): string {
    let displayValue = '-';

    if (cellValue != null) {
        displayValue = `${cellValue}%`;
    }
    return displayValue;
}

export function datePipe(cellValue: DateModel): string {
    let value = '-';
    if (cellValue?.date != null && cellValue?.timezone != null) {
        value = DatepickerHelperService.convertTimestampToDateAndTime(cellValue.date, cellValue.timezone);
    }
    return value;
}
